module.exports = __webpack_public_path__ + "static/media/company-logo.f64a4a6e.png";